import { NgClass } from '@angular/common';
import { Component, input, output, signal } from '@angular/core';

export type ConfirmDialogType = 'danger' | 'warning' | 'info' | 'success';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [NgClass],
  templateUrl: './confirm-dialog.html',
})
export class ConfirmDialog {
  readonly title = input('Confirmar exclusão');
  readonly message = input('Tem certeza que deseja excluir este item?');
  readonly messageEmphasis = input('');
  readonly confirmText = input('Excluir');
  readonly cancelText = input('Cancelar');
  readonly type = input<ConfirmDialogType>('danger');
  readonly promptEnabled = input(false);
  readonly promptLabel = input('Justificativa');
  readonly promptPlaceholder = input('');
  readonly promptRequired = input(true);
  readonly promptMaxLength = input(2000);
  readonly promptRequiredMessage = input('Informe a justificativa.');

  readonly confirmed = output<string>();
  readonly cancelled = output<void>();

  protected readonly promptValue = signal('');
  protected readonly promptError = signal('');

  protected onPromptInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.promptValue.set(value);
    if (value.trim() !== '') {
      this.promptError.set('');
    }
  }

  protected onConfirm(): void {
    const value = this.promptValue().trim();
    if (this.promptEnabled() && this.promptRequired() && value === '') {
      this.promptError.set(this.promptRequiredMessage());
      return;
    }
    this.confirmed.emit(value);
  }

  protected onCancel(): void {
    this.cancelled.emit();
  }
}
